import React, { Component } from 'react';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, get } from 'lodash';
import { Link } from 'react-router-dom';
import ReactSelect from '../../components/common/ReactSelect';
import Datepicker from '../../components/common/Datepicker';
import CountriesList from '../../components/pages/territories/CountriesList';
import MultiSelect from '../../components/pages/territories/MultiSelect';
import Overview from './Overview';
import Details from './Details';
import Accordion from '../../components/widgets/filter/Accordion';
import ranges from '../../components/widgets/filter/enums/ranges.json';

import { vendorsActions } from '../../data/actions/vendors';
import { transactionTypesActions } from '../../data/actions/transaction_types';
import { usersActions } from '../../data/actions/users';
import { filterActions } from '../../data/actions/filter';
import { entityFiltersActions } from '../../data/actions/entity_filters';

const dateFormat = 'YYYY-MM-DD';
const lastMonth = moment().subtract(1, 'month').endOf('month');
const defaultFilter = {
	period: 'quarter',
	dateStart: moment(lastMonth).subtract(1, 'year').format(dateFormat),
	dateEnd: lastMonth.format(dateFormat),
	countries: [],
	imprint: [],
	vendor: [],
	transactionType: []	
}


class TerritoriesList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filterApplied: false,
			...defaultFilter,
			accordion: {
				dates: false,
				period: false,
				imprint: false,
				vendor: false,
				transactionType: false
			},
			filterOpened: false,
			isMobile: false,
			width: 0,
			currentFilterName: "currentFilter",
			currentFilter: {},
			loading: false
		};
		
		this.setContinent = this.setContinent.bind(this);
		this.setFilterProp = this.setFilterProp.bind(this);
		this.dateChange = this.dateChange.bind(this);
		this.filterApply = this.filterApply.bind(this);
		this.filterReset = this.filterReset.bind(this);
		this.setCountries = this.setCountries.bind(this);
		this._getRange = this._getRange.bind(this);
		this.filterToggle = this.filterToggle.bind(this);
	}

	updateDimensions = () => {
		this.setState({ width: window.innerWidth });
		console.log("widthstate", window.innerWidth)
	};
	
	componentDidMount(){
		const { match, dispatch } = this.props;
		const continentName = match.params.continent;
		dispatch(usersActions.getImprints());
		dispatch(vendorsActions.getVendors());

		dispatch(transactionTypesActions.getTransactionTypes());

		dispatch(entityFiltersActions.getAllEntityFilters()).then(filters=>{
			const continent = find(filters, f=>f.name == continentName);
			if(continent) {
				this.setState({
					continent
				})
			}
		})


		this.updateDimensions();
		this.match = window.matchMedia(`(max-width: 1279px)`);
		this.checkWidth = (e) => {    
			if (e.matches) {
				this.setState({
					isMobile: true
				})
			}
		};

		this.checkWidth(this.match);
		this.match.addListener(this.checkWidth);

		window.addEventListener('resize', this.updateDimensions);
		dispatch(filterActions.getMaxDate(true)).then(dateEnd=>{
			const dateStart = moment(dateEnd).subtract(1, 'year').startOf('month').format(dateFormat);
			this.setState({
				dateStart,
				dateEnd,
				maxDateEnd: dateEnd,
				filterApplied: true
			});
		})

	}
	
	getMaxDate(field) {
		let maxDate;
		switch(field) {
			case 'dateStart':
				maxDate = moment(this.state.dateEnd).subtract(1, 'days');
				break;	
		}
		return maxDate.format(dateFormat);
	}


	componentWillUnmount() {
		this.match.removeListener(this.checkWidth);
		window.removeEventListener('resize', this.updateDimensions);
	}
	
	setContinent(continent){
		if(!this.state.continent || this.state.continent.id != continent.id) {
			this.setState({continent, countries: [], loading: true});
			this.props.history.push(`/territories/${continent.name}`);
		}
	}
	
	componentDidUpdate(prevProps) {
		const { territories } = this.props;
		const prevTerritories = prevProps.territories;
		
		// Check if we were loading and now BOTH are complete
		const wasLoading = prevTerritories.loading || prevTerritories.monthsLoading;
		const isNowLoaded = !territories.loading && !territories.monthsLoading;
		
		if (wasLoading && isNowLoaded) {
			this.setState({ loading: false });
		}
	}

	setFilterProp(option, key){
		console.log(option, key);
		if(option === null)
			option = [];
		this.setState({[key]: option});
	}
		

	setPeriod({value: period}){
		this.setState({
			period,
		});
	}

	_getSelectedDuration(dateStart, dateEnd) {
		const dateDiff =  moment(dateEnd).diff(moment(dateStart), 'days');
		return moment.duration(dateDiff, 'days').asDays();
	}
	
	setCountries(countries) {
		this.setState({countries});
	}

	_getRange({dateStart, dateEnd}) {
		let selectedDuration = this._getSelectedDuration(dateStart, dateEnd),
				selectedRange = ranges[0];

		for(let rangeID = ranges.length-1; rangeID>=0; rangeID--) {
				if(ranges[rangeID].range <= selectedDuration) {
						selectedRange = ranges[rangeID];
						break;
				}
		}

		let newRange = selectedRange.value;
		if(this.state) {
				let currentRange = this.state.filter.range;
				if((newRange == 'clwk' && currentRange == 'chwk') || (newRange == 'chwk' && currentRange == 'clwk'))
						newRange = currentRange;
		}
		return newRange;
	}

	_getPrevDateRange({dateStart, dateEnd}) {
		const duration = this._getSelectedDuration(dateStart, dateEnd),
			prevDateEnd = moment(dateStart).subtract(1, 'days'),
			prevDateStart = prevDateEnd.clone().subtract(duration, 'days');

		return {
			prevDateStart: prevDateStart.format(dateFormat),
			prevDateEnd: prevDateEnd.format(dateFormat)
		}
	}

	dateChange(date, propDate) {
	  date = moment(date);
	  let dateStart = moment(this.state.dateStart);

	  if(propDate == 'dateEnd'){
		  date = date.set('date', date.daysInMonth());
		  if(date.isBefore(dateStart))
		  	dateStart = moment(date).set('date', 1);
	  }
	  date = date.format(dateFormat);
	  dateStart = dateStart.format(dateFormat);
	  
	  this.setState({
		  dateStart,
		  [propDate]: date
	  });
	}
	
	filterApply(){
		this.setState({
			filterApplied: false
		}, ()=>{
			this.setState({
				filterApplied: true
			});	
		})
	}
	
	toggleAccordion = (selectedKey) => {
		let {
			accordion
		} = this.state;
		for (let key in accordion) {
			accordion[key] = (key == selectedKey) ? !accordion[key] : false;
		}

		this.setState({
			accordion
		})
	}

	closeAccordion = (selectedKey) =>  {
		let { accordion } = this.state;

		for (let key in accordion) {
			if (key == selectedKey) {
				accordion[key] = false;
			}
		}
		this.setState({
			accordion
		})
	}

	filterReset = () => {
		this.setState({
			...defaultFilter,
			filterApplied: true,
			isMobile: this.state.isMobile,
			width: this.state.width,
			filterOpened: this.state.filterOpened
		});
	};

	filterToggle() {
		this.setState({
			filterOpened: !this.state.filterOpened
		}) 
	}
	
	render() {
		const { continent: selectedContinent = {}, period, dateStart, dateEnd, filterApplied, imprint, vendor, transactionType, maxDateEnd } = this.state;
		const isMobileWidth = this.state.width < 1280 ? true : false;
		const filterMobileClass = isMobileWidth ? "mobile-filter" : "";
		const filterOpenedClass =  isMobileWidth && !this.state.filterOpened ? "filter-closed" : "";
		const periods = [
			{ label: 'Years', value: 'year' },
			{ label: 'Quarters', value: 'quarter' },
			{ label: 'Months', value: 'month' }
		];
		const periodValue = find(periods, p=>p.value == this.state.period);
		const { territories } = this.props;
		const isDisabled = territories.loading || territories.monthsLoading || this.state.loading;
		
		let vendors = get(this.props, 'vendors.vendors', []);
		let transactionTypes = get(this.props, 'transactionTypes.transactionTypes', []);
		let imprints = get(this.props, 'users.imprints', []);
		vendors = vendors.map(v=>({label: v.name, value: v.name}));
		transactionTypes = transactionTypes.map(t=>({label: t.name, value: t.name}));
		imprints = imprints.map(i=>({label: i.name, value: i.id}));

		const imprintValue = find(imprints, i=>(i.value === imprint));
		const vendorValue = find(vendors, v=>(v.value === vendor));
		const transactionTypeValue = find(transactionTypes, t=>(t.value === transactionType));
		
		const filters = get(this.props, 'entityFilters.allEntityFilters', []);
		
		return <div className="inner-page territories-wrapper">
			<div className="territories-filter main-filter-container">
				<div className="filter-wrapper">
					<h2 className="filter-title">Filters</h2>
					{isMobileWidth && <div className="filter-toggle-btn" onClick={this.filterToggle}><span className="fa fa-sliders"></span></div>}

					<div className={`filter-main-form ${filterMobileClass} ${filterOpenedClass}`}>
						<div className='filter-wrapper-inner'>
							<div className="form-group">
								<Accordion className="chosen-group" id="dates" label="Date Range" accordion={this.state.accordion} toggleAccordion={this.toggleAccordion} dateStart={this.state.dateStart} dateEnd={this.state.dateEnd} closeAccordion={this.closeAccordion} readonly={false} >
									<label className="filter-dropdown-label">Current Date Range:</label>
									<div className="daterange-container" id="territory-filter-daterange-container">
										<Datepicker  endDate={this.getMaxDate('dateStart')} date={this.state.dateStart} label="From" dateChange={(date)=>this.dateChange(date, 'dateStart')} container="#territory-filter-daterange-container" />
										<Datepicker  endDate={maxDateEnd} date={this.state.dateEnd} label="To" dateChange={(date)=>this.dateChange(date, 'dateEnd')} container="#territory-filter-daterange-container" />
										</div>
								</Accordion>
							</div>
							<div className="form-group">
								<Accordion className="chosen-group" id="imprint" label="Imprints:" accordion={this.state.accordion} toggleAccordion={this.toggleAccordion} multiValue={imprint} closeAccordion={this.closeAccordion} readonly={false}>
									<ReactSelect isMulti={true} value={imprint} options={imprints} onChange={(o)=>this.setFilterProp(o, 'imprint')} className="single-select"/>
								</Accordion>
							</div>
							<div className="form-group">
								<Accordion className="chosen-group" id="vendor" label="Platforms:" accordion={this.state.accordion} toggleAccordion={this.toggleAccordion} multiValue={vendor} closeAccordion={this.closeAccordion} readonly={false}>
									<ReactSelect isMulti={true} value={vendor} options={vendors} onChange={(o)=>this.setFilterProp(o, 'vendor')} className="single-select"/>
								</Accordion>
							</div>
							<div className="form-group">
								<Accordion className="chosen-group" id="transactionType" label="Transaction Types:" accordion={this.state.accordion} toggleAccordion={this.toggleAccordion} multiValue={transactionType} closeAccordion={this.closeAccordion} readonly={false}>
									<ReactSelect isMulti={true} value={transactionType} options={transactionTypes} onChange={(o)=>this.setFilterProp(o, 'transactionType')} className="single-select"/>
								</Accordion>
							</div>

							<div className="form-group">
								<Accordion className="chosen-group" id="period" label="Group by:" accordion={this.state.accordion} toggleAccordion={this.toggleAccordion} periodValue={periodValue.label} closeAccordion={this.closeAccordion} readonly={false}>
									<ReactSelect value={periodValue} options={periods} onChange={(o)=>this.setFilterProp(o.value, 'period')} className="single-select"/>
								</Accordion>
							</div>
						</div>
						<div className="filter-links-holder">
							<div className="form-group reset-link-container">
									<a onClick={(e)=>this.filterReset(e)}>Reset default filters</a>
							</div>
							<div className="form-group button-container">
								<button className="btn btn-primary apply-btn" alt="apply" onClick={this.filterApply}>Apply filter</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='territories-main-content'>
				<ul className="territories-list">
					<div className='territories-header'>
						<li className="territory-item territory-item-caption">Territory Dashboard</li>
						{filters.map(t=> {
							const isSelected = (t.name == selectedContinent.name);
							return <li key={t.name} className={`territory-item ${isSelected ? 'territory-item-selected':''} ${isDisabled ? 'territory-item-disabled':''}`}>
								<div className={"territory-item-inner"}>
									<span onClick={()=>{!isDisabled && this.setContinent(t)}}>{t.name}</span>
									{!t.is_system && <Link to={`/territories/filters/${t.id}`} className="edit-filter"><i className="fa fa-edit" /></Link>}
								</div>
								{!t.is_system && <span className="custom-filter">(custom)</span>}
								{(isSelected && !(t.overview)) && <CountriesList continent={t.name} filterCountries={t.countries} selectedCountries={this.state.selectedCountries} setSelectedCountries={(o)=>this.setFilterProp(o, 'countries')} />}
							</li>
						})}
						<li className="territory-item add-new"><div className="territory-item-inner"><Link to={`/territories/filters/new`}><span>Add New </span><span className="fa fa-plus add-icon" /></Link></div></li>
					</div>
					
				</ul>
				{filterApplied && filters.map(t=>{
					const PageToRender = t.overview ? Overview : Details;
					const isSelected = t.name == selectedContinent.name;
					const allCountries = t.worldwide ? [] : t.countries;
					let countries = Array.isArray(this.state.countries) && this.state.countries.length ? this.state.countries : allCountries;
					countries = countries.map(c=>c.value);
					
					const imprintValue =  imprint.map(i=>i.value);
					const vendorValue =  vendor.map(v=>v.value);
					const transactionTypeValue =  transactionType.map(t=>t.value);
					const primaryCountries = ( isSelected && this.state.countries.length > 0 ) ? countries : t.primaryCountries;
					return <Route key={t.name} path={`/territories/${t.name}`} render={(props)=><PageToRender key={t.name} continent={t.name} primaryCountries={primaryCountries} countries={countries} period={period} dateStart={dateStart} dateEnd={dateEnd} vendor={vendorValue} transactionType={transactionTypeValue} imprint={imprintValue} {...props} />}></Route>

				})}
			</div>
		</div>
	}
	
}

function mapStateToProps(state) {
	return {
		users: state.users,
		vendors: state.vendors,
		transactionTypes: state.transactionTypes,
		entityFilters: state.entity_filters,
		territories: state.territories,
	}
}


export default withRouter(connect(mapStateToProps)(TerritoriesList));
